<cache-date></cache-date>

<div class="row">
	<div class="col-md-12">&nbsp;</div>
</div>

<div class="row">
	<div class="col-md-4">
		<nav class="nav nav-pills flex-column flex-sm-row">
			<a
				[class]="isLiveData ? 'flex-sm-fill text-sm-center nav-link active' : 'flex-sm-fill text-sm-center nav-link'"
				[routerLink]="['/' + baseUrl]"
				[queryParams]="{isLiveData: true, year: year}"
			>
				Живые
			</a>
			
			<a
				[class]="isLiveData ? 'flex-sm-fill text-sm-center nav-link' : 'flex-sm-fill text-sm-center nav-link active'"
				[routerLink]="['/' + baseUrl]"
				[queryParams]="{isLiveData: false, year: year, isByYears: false}"
			>
				Замороженные
			</a>
		</nav>
	</div>
	<div class="col-md-4">
		<nav class="nav nav-pills flex-column flex-sm-row">
			<a
				[class]="isByYears ? 'flex-sm-fill text-sm-center nav-link active' : 'flex-sm-fill text-sm-center nav-link'"
				[routerLink]="['/' + baseUrl]"
				[queryParams]="{isByYears: true}"
			>
				По годам
			</a>
			
			<a
				[class]="isByYears ? 'flex-sm-fill text-sm-center nav-link' : 'flex-sm-fill text-sm-center nav-link active'"
				[routerLink]="['/' + baseUrl]"
				[queryParams]="{isByYears: false}"
			>
				За год
			</a>
		</nav>
	</div>
	<div class="col-md-4">
		<nav
			class="nav nav-pills flex-column flex-sm-row"
			*ngIf="!isByYears"
		>
			<ng-container *ngFor="let yyyy of years">
				<a
					[class]="yyyy == year ? 'period-tab flex-sm-fill text-sm-center nav-link active' : 'period-tab flex-sm-fill text-sm-center nav-link'"
					[routerLink]="['/' + baseUrl]"
					[queryParams]="{isLiveData: isLiveData, year: yyyy, isByYears: false}"
					[attr.tab]="yyyy"
					[sextant]="'period'"
				>
					{{ yyyy }}
				</a>
			</ng-container>
		</nav>
	</div>
	<div class="col-md-6"></div>
</div>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<loading_percent [percent]="tableLoader"></loading_percent>

<br />

<style>
	.tablecontainer {
		min-width: 2110px;
		overflow-y: hidden;
		overflow-x: auto;
	}
	
	.tablecontainer th, td:not(:first-child) {
		width: 140px;
	}
	
	.tablecontainer thead th:first-child {
		min-width: 400px;
		width: 400px;
	}

	.tablecontainer tbody td:first-child {
		min-width: 400px;
		width: 400px;
	}
	
	.tablecontainer thead { display: block}
	
	.tablecontainer tbody {
		display: block;
		height: 700px;
		overflow-y: auto;
		overflow-x: hidden;
	}
</style>

<div class="tablecontainer">
	<table
		class="table table-bordered table-striped table-sm"
		[sextant]="'table'"
	>
		<thead>
			<tr class="table-success">
				<th>&nbsp;</th>
				<th
					[colSpan]="months.length"
					style="text-align: center;"
				>
					{{ isByYears ? '&nbsp;': year }}
				</th>
			</tr>
			
			<tr class="table-success">
				<th>&nbsp;</th>
				<th *ngFor="let month of months">
					{{ month }}
				</th>
			</tr>
		</thead>
		
		<tbody>
			<tr
				*ngFor="let row of y"
				[class]="'table-' + row.class"
			>
				<td [colSpan]="row.isData ? 1 : (months.length + 1)">
					<span
						[class]="currencyList.includes(row.title.toLowerCase()) ? 'float-right font-weight-bold' : 'fake'">
						{{ row.title || '&nbsp;' }}
					</span>
				</td>
				
				<ng-template [ngIf]="row.isData">
					<td
						*ngFor="let column of columns; let i = index"
						[sextant]="'row-with-data-' + i"
					>
						{{ row.id == 'totalWithoutDomains' || row.id == 'total' ? '$' : '' }}
						
						{{ column[row.id] }}
						
						{{ row.id == 'recurentPercent' || row.id == 'repeatTotalPercent' ? '%' : '' }}
						
						<trend [val]="column[row.id + '_delta']">
							{{ column[row.id + '_delta'] }}
						</trend>
					</td>
				</ng-template>
			</tr>
		</tbody>
	</table>
</div>
